import apisauce from "apisauce";

let SERVER_URL = "https://portal1.glaceemr.com:443/glaceportal_data/api/portal";

const create = (baseURL = SERVER_URL) => {
  const api = apisauce.create({
    baseURL,
    headers: {
      // "Cache-Control": "no-cache"
    },
    timeout: 25000
  });

  const createGetApiCall = (endpoint, params, callback) => {
    api.get(endpoint, params).then(res => {
      callback(res);
    });
  };

  const createPostApiCall = (endpoint, params, callback) => {
    api.post(endpoint, params).then(res => {
      callback(res);
    });
  };


  const getPracticeLocations = (params, callback) => {
    createGetApiCall("/user/PortalAppointments/QuickBook/AppointmentBookCategoriesList", params, callback);
  };

  const getApptType = (params, callback) => {
    createGetApiCall("/user/PortalAppointments/QuickBook/getApptType", params, callback);
  };


  const getDoctorsList = (params, callback) => {
    createGetApiCall("/user/PortalAppointments/QuickBook/AppointmentBookDoctorsList", params, callback);
  };


  const getFreeSlots = (params, callback) => {
    createGetApiCall("/user/PortalAppointments/QuickBook/FreeSlots", params, callback);
  };

  const getSchedulerDetails = (params, callback) => {
    createGetApiCall("/user/PortalAppointments/QuickBook/AppointmentDetails", params, callback);
  };

  const getDefaultQuickbookReason = (params, callback) => {
    createGetApiCall("/user/PortalAppointments/QuickBook/defaultQuickbookReason", params, callback);
  };

  const getInsNames = (params, callback) => {
    createGetApiCall("/user/PortalSettings/QuickBook/getInsuranceNames", params, callback);
  };

  const bookAppointment = (dbname, params, callback) => {
    const patientId = (params && params.patientId !== undefined && params.patientId !== null && params.patientId !== "") ? params.patientId : -1;
    createPostApiCall("/user/PortalAppointments/QuickBook/BookAppointment?dbname=" + dbname + "&patientId=" + patientId, params, callback);
  };
  const getRelationReference = (params, callback) => {
    createGetApiCall("/user/PortalAppointments/QuickBook/getReference", params, callback);
  };

  const getGroupTheropyValues = (params, callback) => {
    createGetApiCall("/user/GroupTheropy/ListDefaultValues", params, callback);
  };
  const sendOptForVaildation = (params, callback) => {
    createGetApiCall("/user/GroupTheropy/otpSend", params, callback);
  };
  const savePatientInfo = (dbname, params, callback) => {
    createPostApiCall("/user/GroupTheropy/savePatientInfo?dbname=" + dbname, params, callback);
  };
  const checkApptRequest = (params, callback) => {
    createGetApiCall("/user/PortalAppointments/QuickBook/checkFroReq", params, callback);
  };
  const getPatientDetails = (params, callback) => {
    createGetApiCall("/user/PortalAppointments/QuickBook/getPatientDetails", params, callback);
  };
  return {
    getPracticeLocations, getApptType, getDoctorsList, getFreeSlots, getSchedulerDetails, getDefaultQuickbookReason, getInsNames, bookAppointment, getRelationReference, getGroupTheropyValues, sendOptForVaildation, savePatientInfo, checkApptRequest, getPatientDetails
  };

};
export default {
  create
};